import { Link } from 'react-router-dom'

import styles from './Footer.module.css'

const Footer = () => {
    
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div className={styles.footer}>
            <div className={styles.footerSection1}>
                <div className={styles.footerLinks}>
                    <h2>Socialin</h2>
                </div>
                <div className={styles.footerLinks}>
                    <Link to="/features" onClick={scrollToTop}><span>Funcions</span></Link>
                    <Link to="/info" onClick={scrollToTop}><span>Sobre nosaltres</span></Link>
                    <Link to="/info-contacte" onClick={scrollToTop}><span>Informació de contacte</span></Link>
                    <a href="mailto:codelabosona@gmail.com" className={styles.emailLink}><span>Contacta'ns</span></a>
                </div>
                <div className={styles.footerLinks}>
                    <Link to="/info-legal#informacio-legal" onClick={scrollToTop}><span>Informació legal</span></Link>
                    <Link to="/info-legal#politica-privacitat" onClick={scrollToTop}><span>Política de privacitat</span></Link>
                    <Link to="/info-legal#politica-cookies" onClick={scrollToTop}><span>Política de cookies</span></Link>
                </div>   
            </div>   
            <div className={styles.footerSection2}>
                <p>&copy; 2024 Socialin by Josep Tarrés Toneu - CodeLabOsona. Tots els drets reservats.</p>
                <Link to="https://www.instagram.com/socialin_es" target="_blank"><i className="fa-brands fa-instagram"></i></Link>
                <Link to="https://x.com/socialin_es" target="_blank"><i className="fa-brands fa-square-x-twitter"></i></Link>
            </div>   
        </div>
    )
}

export default Footer